import React from 'react';
import { Box, SelectComponent } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { dateRangeModes } from '@epi-constants/downloadReports';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';
import { setStartDate, setEndDate } from '@epi-helpers/reportsHelper';

interface TransactionsSelectRangeProps {
  setPage: (page: number) => void;
  setShowCalendar: (isOpen: boolean) => void;
  timePeriodType?: string;
  setTimePeriodType: (type: string) => void;
  from: string | Date | null;
  setFrom: (from: string | null) => void;
  to: string | Date | null;
  setTo: (to: string | null) => void;
}

export const TransactionsSelectRange = ({
  setPage,
  setShowCalendar,
  timePeriodType,
  setTimePeriodType,
  from,
  setFrom,
  to,
  setTo
}: TransactionsSelectRangeProps) => {
  const { t } = useTranslation();

  const datePicker =
    from && to && timePeriodType === dateRangeModes.datePicker
      ? `${apiToDefaultDateFormat(from)} - ${apiToDefaultDateFormat(to)}`
      : t('download_reports.lunch_deduction.time_period.select_dates');

  const options = [
    {
      display: t('download_reports.lunch_deduction.time_period.previous_month'),
      id: dateRangeModes.lastMonth
    },
    {
      display: t('download_reports.lunch_deduction.time_period.current_month'),
      id: dateRangeModes.currentMonth
    },
    {
      display: datePicker,
      id: dateRangeModes.datePicker
    }
  ];

  const handleTimePeriodChange = value => {
    setTimePeriodType(value.id);
    if (value.id === dateRangeModes.datePicker) {
      setFrom(null);
      setTo(null);
      setShowCalendar(true);
    } else {
      setFrom(setStartDate(value.id));
      setTo(setEndDate(value.id));
    }
    setPage(1);
  };

  return (
    <Box ml={-1} zIndex={0} position={'relative'}>
      <SelectComponent
        label=""
        placeholder={t('containers.deposit_money.corrections_tab.placeholder')}
        id="report-date-range-select"
        selectedId={timePeriodType}
        options={options}
        onChange={handleTimePeriodChange}
      />
    </Box>
  );
};
